import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 35 26",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M31.5 19.904V5.252l-7.567 6.92 7.567 7.732zm-2.301 2.63l-7.838-8.01-1.487 1.359a3.525 3.525 0 01-4.748 0l-1.473-1.347-7.85 7.997h23.396zM3.5 19.905l7.58-7.722L3.5 5.252v14.654zm3.207-16.44l10.793 9.87 10.793-9.87H6.707zM3.5 0h28C33.433 0 35 1.552 35 3.467v19.066C35 24.448 33.433 26 31.5 26h-28C1.567 26 0 24.448 0 22.533V3.467C0 1.552 1.567 0 3.5 0z",
		fillRule: "nonzero"
	})
});
export default SvgFieldEmail;
